import { render, staticRenderFns } from "./SalesforceForm.vue?vue&type=template&id=fdf0295c"
import script from "./SalesforceForm.vue?vue&type=script&lang=ts"
export * from "./SalesforceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports